<template lang='pug' src='./QuotesList.pug'></template>

<script>
  import Quote from '../Quote/Quote'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    components: {
      Quote
    },
    date () {
      return {
        loading: false,
        windowHeight: undefined,
        lastElem: undefined
      }
    },
    computed: {
      ...mapGetters([
        'getQuotes',
        'getChangeQuotes',
        'getPager'
      ])
    },
    watch: {
      getQuotes: {
        handler: function () {
          this.loading = false
        },
        immediate: true
      }
    },
    updated () {
      this.lastElem = Array.from(this.$el.querySelectorAll('.quote')).pop()
      this.windowHeight = window.innerHeight
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
      ...mapActions([
        'setActiveQuote',
        'setChangeQuotes',
        'showMore'
      ]),
      showAddQuote: function () {
        this.setChangeQuotes(true)
        this.setActiveQuote({})
      },
      handleScroll: function () {
        if (this.loading) {
          return
        }

        if (!this.getPager.after) {
          return
        }

        let position = this.lastElem.getBoundingClientRect()
        position = position.bottom - Math.floor(position.height)

        if (position <= this.windowHeight) {
          this.showMore(this.getQuotes)
          this.loading = true
        }
      }
    }
  }
</script>

<style lang='css' src='./QuotesList.css' scoped></style>



// WEBPACK FOOTER //
// QuotesList.vue?2b5ac267